import SignInForm from 'components/modules/auth/SignInForm';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { useAccessToken } from 'providers/AccessTokenProvider';
import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { LOGIN } from 'services/api/auth';

const SignIn = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const {
    setAuthUser,
    setPermissions,
    authUser,
    isSessionLoading,
    refreshSession
  } = useAccessToken();

  useEffect(() => {
    if (!isSessionLoading && authUser) {
      navigate('/home/apps/job/project-card-view');
    }
  }, [authUser, navigate, isSessionLoading]);

  const login = useMutation('login', LOGIN, {
    onSuccess: async (data: any) => {
      setIsSuccessful(true);
      const {
        data: { authUser: loginUser }
      } = data.data;
      const permissions =
        loginUser?.roles?.flatMap((role: any) => role.permissions) || [];
      if (loginUser) {
        setAuthUser({ ...loginUser, isAdmin: loginUser.isAdmin || false });
        setPermissions(permissions);
      }
      const refreshed = await refreshSession();
      if (!refreshed) {
        setErrorMessage('Unable to refresh session after login.');
      }
    },
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (error: any) => {
      setErrorMessage(error?.response?.data?.messages);
      setIsLoading(false);
    }
  });
  useEffect(() => {
    if (isSuccessful) {
      toast.success('Login successful');
      navigate('/home/apps/job/project-card-view');
    }
  }, [isSuccessful, setIsSuccessful]);

  const handleLogin = async (formData: any) => {
    try {
      await login.mutateAsync({
        email: formData.email,
        password: formData.password
      });
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.messages);
    }
  };
  return (
    <AuthCardLayout className="pb-md-7">
      <SignInForm
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        layout="card"
        handleLogin={handleLogin}
        errorMessage={errorMessage}
        isLoading={isLoading}
      />
    </AuthCardLayout>
  );
};

export default SignIn;
